import { Alert, Box } from '@mui/material';
import dayjs from 'dayjs';
import { useContext, useMemo } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import { SelectedProgramContext } from '@/Contexts/SelectedProgramContext';

function PortalClosedBanner({ applicationTypeId }: { applicationTypeId: number }) {
  const { selectedProgramInfo, programLatestAppCycle, programNextAppCycle } =
    useContext(SelectedProgramContext);
  const { translatedText } = useContext(LocaleContext);

  const latestAppCycle = useMemo(
    () => (programLatestAppCycle != null ? programLatestAppCycle[applicationTypeId] : null),
    [applicationTypeId, programLatestAppCycle]
  );

  const nextAppCycleOpenDate = useMemo(() => {
    const openDate = programNextAppCycle != null ? programNextAppCycle[applicationTypeId]?.openDate : null;

    return openDate != null ? dayjs(openDate).format('LL') : null;
  }, [applicationTypeId, programNextAppCycle]);

  return selectedProgramInfo != null && latestAppCycle != null ? (
    <Box display='flex' justifyContent='center' gap='20px' paddingTop={1}>
      <Alert severity='warning'>
        {translatedText.dashboard.portalClosedInformation(
          latestAppCycle.year.toString(),
          nextAppCycleOpenDate
        )}
      </Alert>
    </Box>
  ) : (
    <></>
  );
}

export default PortalClosedBanner;
